import { Config } from '~/api/def/endpoints/dashboardEndpoint';
import {
  getDefaultDashboardLayout,
  getDefaultDashboardName,
  getDefaultDashboardDescription,
} from '~/config/organizationConfig';

// Legacy exports for backward compatibility - these will be deprecated
export const DEFAULT_DASHBOARD_NAME_SL = 'Visible Alpha';
export const DEFAULT_DASHBOARD_DESCRIPTION_SL =
  'Default dashboard with standard widgets';

// Pre-generated default layout with unique IDs - UUIDs generated once when module loads
export const DEFAULT_DASHBOARD_LAYOUT_SL: Config[] = [
  {
    h: 10,
    w: 4,
    x: 0,
    y: 0,
    id: 'proposed-portfolio',
    isDynamic: false,
  },
  {
    h: 10,
    w: 8,
    x: 4,
    y: 0,
    id: 'risk-alerts',
    isDynamic: false,
  },
  {
    h: 10,
    w: 4,
    x: 0,
    y: 10,
    id: 'historical-returns',
    isDynamic: false,
  },
  {
    h: 10,
    w: 8,
    x: 4,
    y: 10,
    id: 'forward-returns',
    isDynamic: false,
  },
  {
    h: 16,
    w: 12,
    x: 0,
    y: 20,
    id: 'sector-allocation',
    isDynamic: false,
  },
];

// Keep the function for backward compatibility if needed elsewhere
export const getDefaultLayoutSL = (): Config[] => DEFAULT_DASHBOARD_LAYOUT_SL;

// New organization-aware functions
export const getDefaultLayout = (
  orgSlug: string | null | undefined,
): Config[] => getDefaultDashboardLayout(orgSlug);

export const getDefaultName = (orgSlug: string | null | undefined): string =>
  getDefaultDashboardName(orgSlug);

export const getDefaultDescription = (
  orgSlug: string | null | undefined,
): string => getDefaultDashboardDescription(orgSlug);
